export default __webpack_public_path__ + "static/media/im-placeholder-comment.9bc23c97.svg";